import Airport from './airport.svg';
import ArrowLeft from './arrow-left.svg';
import ArrowRight from './arrow-right.svg';
import Book from './book.svg';
import Briefcase from './briefcase.svg';
import Bus from './bus.svg';
import CalendarDepart from './calendar-depart.svg';
import CalendarReturn from './calendar-return.svg';
import Calendar from './calendar.svg';
import Check from './check.svg';
import CheckCircle from './check-circle.svg';
import Chevron from './chevron.svg';
import ChevronLeft from './chevron-left.svg';
import ChevronRight from './chevron-right.svg';
import ChevronTop from './chevron-top.svg';
import ChildBooster from './child-booster.svg';
import ChildChair from './child-chair.svg';
import ChildCradle from './child-cradle.svg';
import City from './city.svg';
import Clock from './clock.svg';
import CloseCircle from './close-circle.svg';
import FemaleMale from './female-male.svg';
import Harbour from './harbour.svg';
import Hotel from './hotel.svg';
import Info from './info.svg';
import Invoice from './invoice.svg';
import Island from './island.svg';
import Logo from './logo.svg';
import Magnifer from './magnifier.svg';
import Minus from './minus.svg';
import Pencil from './pencil.svg';
import Phone from './phone.svg';
import Plus from './plus.svg';
import Point from './point.svg';
import Remove from './remove.svg';
import Suitecase from './suitecase.svg';
import Swap from './swap.svg';
import TrainStation from './train-station.svg';
import User from './user.svg';
import InfoCircle from './info-circle.svg';
import NoOrders from './no-orders.svg';
import Warning from './warning.svg';

export default {
  Airport,
  ArrowLeft,
  ArrowRight,
  Book,
  Briefcase,
  Bus,
  CalendarDepart,
  CalendarReturn,
  Calendar,
  Check,
  CheckCircle,
  Chevron,
  ChevronLeft,
  ChevronRight,
  ChevronTop,
  ChildBooster,
  ChildChair,
  ChildCradle,
  City,
  Clock,
  CloseCircle,
  FemaleMale,
  Harbour,
  Hotel,
  Info,
  Invoice,
  Island,
  Logo,
  Magnifer,
  Minus,
  Pencil,
  Phone,
  Plus,
  Point,
  Remove,
  Suitecase,
  Swap,
  TrainStation,
  User,
  InfoCircle,
  NoOrders,
  Warning,
};



// WEBPACK FOOTER //
// ./src/assets/icons/index.js